module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeActions),
      expression: "closeActions"
    }],
    staticClass: "relative radius-large"
  }, [_c('button', {
    staticClass: "btn wider",
    on: {
      "click": _vm.toggleActions
    }
  }, [_vm._v("    \n        " + _vm._s(_vm.label) + "\n        "), _c('span', {
    staticClass: "ml-2",
    class: ['ico-arrow-' + _vm.direction]
  })]), _vm._v(" "), (_vm.showActions) ? _c('ul', {
    staticClass: "floating-menu bottom"
  }, _vm._l((_vm.options), function(option) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.clickOption(option.fn, option.value)
        }
      }
    }, [_vm._v("\n            " + _vm._s(option.label) + "\n        ")])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fdcde7e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DropdownButton.vue
// module id = 2630
// module chunks = 0